module.exports = __webpack_public_path__ + "static/media/logo2.d29b3924.png";